export default function prettyPhone(number) {
    if (!number || typeof number !== 'string') return ' ';

    const digits_only = number.replace(/[^0-9]/g, '');

    if (digits_only.length === 10) {
        return digits_only.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }

    return number;
}
